<template>
    <div v-bind:id="id" class="tab-pane fade">
        <slot v-if="list.length > 0">
            <div class="row">
                <div v-for="(row, index) in top" class="col-xs-12 col-sm-6 col-md-6">
                    <div class="filter">
                        <a :href="row.url">
                            <img v-bind:src="row.img" width="100%" height="auto" class="filter_img">
                        </a>
                        <div class="filter_wrapper">
                            <a :href="row.author.url">
                                <img v-bind:src="row.author.img" class="filter_photo">
                                <div class="filter_name">{{row.author.ara_nickname}}</div>
                            </a>
                            <div v-if="false" class="filter_view"><i class="fas fa-eye"></i>{{row.ar_count}}
                            </div>
                            <a :href="row.url">
                                <h1 class="filter_title JQellipsis"
                                    len="22">{{tc_left(row.ar_ti,19)}}</h1>
                            </a>
                            <p class="filter_content JQellipsis"
                               len="26">{{tc_left(html_filter(row.ar_x1),23)}}</p>
                            <slot v-if="check_tags(row.tags)">
                                <a :href="row.tags[0]['url']">
                                    <b class="filter_tag">{{row.tags[0]['art_nickname']}}</b>
                                </a>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
            <div v-for="(row,index) in body" class="row">

                <div v-for="(row1,index1) in row" class="col-xs-12 col-sm-4 col-md-4">
                    <div class="filter">
                        <a :href="row1.url">
                            <img v-bind:src="row1.img" width="100%" height="auto" class="filter_img">
                        </a>
                        <div class="filter_wrapper">
                            <a :href="row1.author.url">
                                <img v-bind:src="row1.author.img" class="filter_photo">
                                <div class="filter_name">{{row1.author.ara_nickname}}</div>
                            </a>
                            <div v-if="false" class="filter_view"><i class="fas fa-eye"></i>{{count(row1.ar_count)}}
                            </div>
                            <a :href="row1.url">
                                <h1 class="filter_title JQellipsis"
                                    len="22">{{tc_left(row1.ar_ti,19)}}</h1>
                            </a>
                            <p class="filter_content JQellipsis"
                               len="26">{{tc_left(html_filter(row1.ar_x1),23)}}</p>
                            <slot v-if="check_tags(row1.tags)">
                                <a :href="row1.tags[0]['url']">
                                    <b class="filter_tag">{{row1.tags[0]['art_nickname']}}</b>
                                </a>
                            </slot>

                        </div>
                    </div>
                </div>
            </div>
            <!--更多文章-->
            <div v-if="next_page_bottom" class="more btn_white">
                <div class="line"></div>
                <div class="more_btn">
                    <a v-on:click="next_page">更多文章</a>
                </div>
            </div>
        </slot>
        <slot v-else>
            <div class="row">
                <div class="col-md-6 col-md-offset-3 searchNoResult">
                    <img :src="`${get_host}images/article/search/search.svg`">
                    <p>哎呀，沒有相關文章，<br>試試看別的關鍵字，<br>或是回<a :href="`${get_host}articles/main`">保險文章</a>，看精選文章吧～</p>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: "List",
        props: {
            id: String,
            listField: String,
        },
        data: function () {
            return {
                list_field: this.listField
            }
        },
        created() {

        },
        methods: {
            next_page() {
                const self = this;
                const next = parseInt(self.$route.params[self.list_field]) + 1;
                console.log(self.routerName)
                if (next <= self.$store.state[self.list_field].totalPage) {

                    self.$router.push({name: self.routerName, params: self.merge_page(next)});
                }
            },
            merge_page(value) {
                const self = this;
                let assign = {};
                assign[self.list_field] = value;
                let target = {};
                if(self.$route.params.arty){
                    target['arty'] = self.$route.params.arty;
                }
                if(self.$route.params.keyword){
                    target['keyword'] = self.$route.params.keyword;
                }
                target['latest_list'] = self.$route.params.latest_list;
                target['hot_list'] = self.$route.params.hot_list;
                return _.assign(target, assign);
            },
            check_tags(value) {

                if(value.length > 0)
                    return true;
                return false;
            }
        },
        computed: {
            routerName(){
                return this.$store.getters.routerName
            },
            list(){
                return this.$store.getters.list(this.list_field)
            },
            page(){
                return this.$store.getters.page(this.list_field)
            },
            totalPage(){
                return this.$store.getters.totalPage(this.list_field)
            },
            next_page_bottom() {
                const self = this;
                if (self.$route.params[self.list_field] >= self.totalPage) {
                    return false;
                }
                return true;
            },
            top() {
                const self = this;
                const top = _.filter(self.list, function (o, i) {
                    if (i < 2) {
                        return true;
                    }
                    return false;
                })
                return top;
            },
            body() {
                const self = this;
                const f = _.filter(self.list, function (p, i) {
                    if (i >= 2) {
                        return true;
                    }
                    return false;
                });
                let list = [];
                let j = -1;
                for (let i = 0; i < f.length; i++) {
                    if (i % 3 == 0) {
                        j++;
                        list.push([]);
                    }
                    list[j].push(f[i]);
                }
                return list;
            },
        }
    }
</script>

<style scoped>

</style>